import { type UserDto } from "../models";
import { type UserPermissionFlags } from "../models/permissions";

export function checkPermission(user: UserDto | undefined, flag: UserPermissionFlags) {
    return !!user && (user.permissionFlags & flag) === flag;
}
